<template>
    <div id="reseller-products-wrap">

        <div class="row justify-content-center" v-if="current_step != 'completed'">
            <div class="col-lg-22 col-xl-18">

                <ul class="juh-stepper">

                    <li class="juh-stepper-step" @click="goToStep('products')" :class="{active: (current_step == 'products')}">
                        <button type="button" class="juh-stepper-btn">
                            <span class="juh-stepper-label">Produkte</span>
                            <span class="juh-stepper-number">1</span>
                        </button>
                    </li>

                    <li class="juh-stepper-line"></li>

                    <li class="juh-stepper-step" @click="goToStep('transport')" :class="{active: (current_step == 'transport')}">
                        <button type="button" class="juh-stepper-btn">
                            <span class="juh-stepper-label">Transport</span>
                            <span class="juh-stepper-number">2</span>
                        </button>
                    </li>

                    <li class="juh-stepper-line"></li>

                    <li class="juh-stepper-step" @click="goToStep('contact')" :class="{active: (current_step == 'contact')}">
                        <button type="button" class="juh-stepper-btn">
                            <span class="juh-stepper-label">Anfrage abschließen</span>
                            <span class="juh-stepper-number">3</span>
                        </button>
                    </li>

                </ul>

            </div>
        </div>

        <form>

            <div id="step-products" v-if="current_step == 'products'">

                <div class="product-categories" v-if="categories.items.length > 0 && !categories.loading">
                    <div class="product-category" v-for="category in categories.items" v-bind:key="category.id">

                        <h3 class="h5 mt-4 mb-3">{{ category.name }}</h3>

                        <div class="row" v-if="category.products.length > 0 && !category.loading">

                            <div class="d-flex" :class="itemClass" v-for="product in category.products" v-bind:key="product.id">

                                <input class="card-field" type="checkbox" v-model="selected.products" :value="product" :id="'product-' + product.id">

                                <label class="card w-100 mb-4" :for="'product-' + product.id" :title="product.title.rendered">

                                    <img :src="product.image || fallback_image" :alt="product.title.rendered" class="card-img-top">

                                    <div class="card-body">
                                        <h4 class="card-title" v-html="product.title.rendered"></h4>
                                        <div class="card-text" v-html="product.content.rendered"></div>
                                    </div>

                                    <div class="card-label">
                                        <span class="card-unchecked">
                                            <i class="juh-icon juh-icon-plus mr-1"></i> will ich
                                        </span>
                                        <span class="card-checked">
                                            <i class="juh-icon juh-icon-check mr-1"></i> hab ich
                                        </span>
                                    </div>

                                </label>

                            </div>

                        </div>
                        <div v-else class="text-center p-4 mb-3">
                            <div class="spinner-border text-secondary" role="status">
                                <span class="sr-only">Loading transports...</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-else class="text-center p-4 mb-3">
                    <div class="spinner-border text-secondary" role="status">
                        <span class="sr-only">Loading products...</span>
                    </div>
                </div>

                <div class="form-group" v-if="categories.items.length > 0 && !categories.loading">
                    <button type="button" @click="goToStep('transport')" :disabled="!selected.products.length" class="btn btn-lg btn-block btn-primary">Transport wählen</button>
                </div>

            </div>

            <div id="step-transport" v-if="current_step == 'transport'">

                <div class="row justify-content-center" v-if="transports.items.length > 0 && !transports.loading">

                    <div class="d-flex" :class="itemClass" v-for="transport in transports.items" v-bind:key="transport.id">

                        <input class="card-field" type="radio" @change="goToStep('contact')" v-model="selected.transport" :value="transport" :id="'transport-' + transport.id">

                        <label class="card w-100 mb-4" :for="'transport-' + transport.id" :title="transport.title.rendered">

                            <img :src="transport.image || fallback_image" :alt="transport.title.rendered" class="card-img-top">

                            <div class="card-body">
                                <h4 class="card-title" v-html="transport.title.rendered"></h4>
                                <div class="card-text" v-html="transport.content.rendered"></div>
                            </div>

                            <div class="card-label">
                                <span class="card-unchecked">
                                    <i class="juh-icon juh-icon-plus mr-1"></i> will ich
                                </span>
                                <span class="card-checked">
                                    <i class="juh-icon juh-icon-check mr-1"></i> hab ich
                                </span>
                            </div>

                        </label>

                    </div>

                </div>
                <div v-else class="text-center p-4 mb-3">
                    <div class="spinner-border text-secondary" role="status">
                        <span class="sr-only">Loading transports...</span>
                    </div>
                </div>

                <div class="form-group text-center" v-if="selected.transport.id != undefined">
                    <button type="button" @click="goToStep('contact')" class="btn btn-lg btn-primary">Weiter</button>
                </div>

            </div>

            <div id="step-contact" v-if="current_step == 'contact'">

                <div class="row justify-content-center">
                    <div class="col-md-20 col-lg-16 col-xl-12">

                        <h3 class="h5 mt-4 mb-3">Produkte</h3>

                        <div class="card">
                            <ul class="list-group list-group-flush">

                                <li class="list-group-item p-0" v-for="product in selected.products" v-bind:key="product.id">
                                    <div class="row no-gutters align-items-center p-3">
                                        <div class="col-5">
                                            <img :src="product.image || fallback_image" :alt="product.title.rendered" class="img-fluid">
                                        </div>
                                        <div class="col-15 px-3">
                                            <h4 class="card-title mb-0" v-html="product.title.rendered"></h4>
                                            <div class="card-text" v-html="product.content.rendered"></div>
                                        </div>
                                        <div class="col-4 text-right">
                                            <button @click="removeProduct(product.id)" type="button" class="btn btn-sm text-danger">
                                                <i class="juh-icon juh-icon-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>

                        <h3 class="h5 mt-4 mb-3">Transport</h3>

                        <div class="card">
                            <ul class="list-group list-group-flush">

                                <li class="list-group-item p-0">
                                    <div class="row no-gutters align-items-center p-3">
                                        <div class="col-5">
                                            <img :src="selected.transport.image || fallback_image" :alt="selected.transport.title.rendered" class="img-fluid">
                                        </div>
                                        <div class="col-15 px-3">
                                            <h4 class="card-title mb-0" v-html="selected.transport.title.rendered"></h4>
                                            <div class="card-text" v-html="selected.transport.content.rendered"></div>
                                        </div>
                                        <div class="col-4 text-right">
                                            <button @click="goToStep('transport')" type="button" class="btn btn-sm text-info">
                                                <i class="juh-icon juh-icon-edit"></i>
                                            </button>
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>

                        <h3 class="h5 mt-4 mb-3">Kontaktdaten</h3>

                        <div class="form-group">
                            <input type="text" v-model="form_fields.company" name="company" placeholder="Name deines Ladens *" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('company')}">
                        </div>

                        <div class="form-group">
                            <input type="text" v-model="form_fields.location" name="location" placeholder="Ort deines Ladens *" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('company')}">
                        </div>

                        <div class="form-group">
                            <input type="text" v-model="form_fields.name" placeholder="Name" class="form-control">
                        </div>

                        <div class="form-group">
                            <input type="email" v-model="form_fields.email" name="email" placeholder="E-Mail *" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('email')}">
                        </div>

                        <div class="form-group">
                            <input type="text" v-model="form_fields.phone" placeholder="Telefon" class="form-control">
                        </div>

                        <div class="form-group">
                            <textarea v-model="form_fields.message" placeholder="Nachricht" rows="4" class="form-control"></textarea>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" v-model="form_fields.privacy" name="privacy" id="privacy" v-validate="'required'" :class="{'is-invalid': errors.has('privacy')}">
                                <label class="custom-control-label" for="privacy" :class="{'is-invalid': errors.has('privacy')}">Hiermit stimme ich den <a :href="privacy_link" target="_blank" rel="noopener">Datenschutzbestimmungen</a> zu.</label>
                            </div>
                        </div>

                        <div class="form-group">

                            <button type="button" class="btn btn-lg btn-block btn-primary" @click="submit" :class="{disabled: sending == true}">
                                <span v-if="sending == true">
                                    <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Anfrage wird gesendet...
                                </span>
                                <span v-if="!sending == true">
                                    Unverbindliche Anfrage senden
                                </span>
                            </button>

                        </div>

                    </div>
                </div>

            </div>

            <div id="step-completed" v-if="current_step == 'completed'">
                <div class="h5 text-center">
                    Vielen Dank für deine unverbindliche Event-Buchung.
                </div>
            </div>

        </form>

    </div>
</template>

<script>
export default {
    props: {
        itemClass: String
    },
    data () {
        return {
            ajax_url: wp_ajax_url,
            privacy_link: wp_privacy_url,
            fallback_image: fallback_image,
            current_step: 'products',
            sending: false,
            categories: {
                api_url: wp_url + '/wp-json/wp/v2/reseller_product_category',
                loading: true,
                items: [],
                params: {
                    per_page: 100,
                    order: 'desc',
                },
            },
            products: {
                api_url: wp_url + '/wp-json/wp/v2/reseller_product',
                params: {
                    reseller_product_category: null,
                    per_page: 100,
                    order: 'desc',
                },
            },
            transports: {
                api_url: wp_url + '/wp-json/wp/v2/reseller_transport',
                loading: true,
                items: [],
                params: {
                    per_page: 100,
                    order: 'desc',
                },
            },
            selected: {
                products: [],
                transport: {},
            },
            // completed: false,
            form_fields: {
                company: '',
                location: '',
                name: '',
                email: '',
                phone: '',
                message: '',
                privacy: false,
            }
        }
    },

    mounted() {
        this.getCategories();
        this.getTransports();
    },

    methods: {

        getCategories() {

            var _this = this;

            _this.categories.loading = true;

            $.getJSON(_this.categories.api_url, _this.categories.params, function(categories){
                setTimeout(() => {
                    _this.categories.items = categories;
                    _this.categories.loading = false;
                    for ( var category in categories ) {
                        _this.getProducts(categories[category]);
                    }
                }, 1000);
            });

        },

        getProducts( category ) {

            let _this  = this,
                params = Object.assign(_this.products.params, {
                    reseller_product_category: category.id
                });

            category.loading = true;

            $.getJSON(_this.products.api_url, params, function(products){
                setTimeout(() => {
                    category.products = products;
                    category.loading = false;
                }, 1000);
            });

        },

        getTransports() {

            var _this = this;

            _this.transports.loading = true;

            $.getJSON(_this.transports.api_url, _this.transports.params, function(transports){

                setTimeout(() => {
                    _this.transports.items = transports;
                    _this.transports.loading = false;
                }, 1000);

            });

        },

        removeProduct(id) {

            var _this = this;

            _this.selected.products = _this.selected.products.filter(product => {
                return product.id !== id
            });

            if( _this.selected.products.length === 0 ) {
                _this.goToStep('products');
            }

        },

        goToStep( step ) {

            let _this        = this,
                hasProducts  = Boolean(_this.selected.products.length),
                hasTransport = Boolean(Object.keys(_this.selected.transport).length);

            switch(step) {

                case 'transport':

                    if( !hasProducts ) {
                        step = 'products';
                    }

                    break;

                case 'contact':

                    if( !hasProducts ) {
                        step = 'products';
                    } else
                    if( hasProducts && !hasTransport ) {
                        step = 'transport';
                    }

                    break;

                case 'completed':

                    if( !hasProducts ) {
                        step = 'products';
                    } else
                    if( hasProducts && !hasTransport ) {
                        step = 'transport';
                    }

                    break;

            }

            window.scrollTo(0, 0);
            _this.current_step = step;

            // $('html, body').animate({scrollTop: 0}, {
            //     duration: 200,
            //     complete: function() {
            //         _this.current_step = step;
            //     }
            // });

        },

        submit() {

            var _this = this;

            _this.$validator.validate().then(function(valid) {

                if( valid === true ) {

                    _this.sending = true;

                    var data = Object.assign({
                        action:   'send_order_products',
                        products: _this.selected.products.map(function(product){
                            return {
                                id: product.id,
                                image: product.image,
                                title: product.title.rendered,
                                content: product.content.rendered,
                            };
                        }),
                        transport: {
                            id: _this.selected.transport.id,
                            image: _this.selected.transport.image,
                            title: _this.selected.transport.title.rendered,
                            content: _this.selected.transport.content.rendered,
                        },
                    }, _this.form_fields);

                    $.post(_this.ajax_url, data, function(response){

                        _this.sending = false;
                        _this.current_step = 'completed';

                        _this.selected = {
                            products: [],
                            transport: {},
                        };

                        _this.form_fields = {
                            company: '',
                            location: '',
                            name: '',
                            email: '',
                            phone: '',
                            message: '',
                            privacy: false,
                        };

                    });

                } else {
                    var firstError = $(_this.$el).find('.is-invalid').first();
                    window.scrollTo(0, firstError.position().top);
                }

            }).catch(function(error){

                _this.sending = false;

                console.log(error);

            }).then(function(){

                // _this.sending = false;

                // console.log(_this.sending);

            });

            return;

        }

    }
}
</script>

<style lang="scss"></style>
